import { TFunction } from "i18next";
import { DropzoneOptions, ErrorCode, FileRejection } from "react-dropzone";
import config from "../utils/Config";

export enum DropZoneValidatorErrorCode {
  IMAGE_TOO_LARGE = "image-too-large",
  DOCUMENT_TOO_LARGE = "document-too-large",
  AUDIO_VIDEO_TOO_LARGE = "audio-video-too-large",
  FILE_INVALID_TYPE = ErrorCode.FileInvalidType,
  FILE_TOO_LARGE = ErrorCode.FileTooLarge,
}

export const fileValidator = (fileTooLargeMessage: string) => (file: File) => {
  if (file.size > config.fileSizeLimitBytes) {
    return {
      code: DropZoneValidatorErrorCode.FILE_TOO_LARGE,
      message: fileTooLargeMessage,
    };
  }
  return null;
};

export const getDropZoneBaseConfig = ({
  errorCallback,
  t,
}: {
  errorCallback: (errorMessage: string) => void;
  t: TFunction<"translation", undefined>;
}): DropzoneOptions => ({
  maxSize: config.fileSizeLimitBytes,
  onDropRejected: (fileRejections: FileRejection[]) => {
    const hasFileInvalidType = fileRejections.some(rejection =>
      rejection.errors.some(
        error => error.code === DropZoneValidatorErrorCode.FILE_INVALID_TYPE,
      ),
    );
    if (hasFileInvalidType) {
      errorCallback(
        t("preview.fileNotSupported", { ns: "message" }) ||
          "File type is not supported.",
      );
      return;
    }
    const hasFileTooLarge = fileRejections.some(rejection =>
      rejection.errors.some(
        error => error.code === DropZoneValidatorErrorCode.FILE_TOO_LARGE,
      ),
    );
    if (hasFileTooLarge) {
      errorCallback(
        t("preview.fileSizeError", {
          ns: "message",
          maxFileSize: config.fileSizeLimitBytes / (1024 * 1024),
        }) || "File is too large.",
      );
      return;
    }
  },
});
